/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cra_SubmitInputs */

const en_cra_submit = /** @type {(inputs: Cra_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const ja_cra_submit = /** @type {(inputs: Cra_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確定`)
};

const fr_cra_submit = /** @type {(inputs: Cra_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const de_cra_submit = /** @type {(inputs: Cra_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Cra_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cra_submit = /** @type {((inputs?: Cra_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cra_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cra_submit(inputs)
	if (locale === "ja") return ja_cra_submit(inputs)
	if (locale === "fr") return fr_cra_submit(inputs)
	return de_cra_submit(inputs)
});